import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Paragraph from 'ui/Paragraph';

import { ConnectorStatusTable } from '../common/Status';

const styles = theme => ({
    label: {
        fontWeight: 500,
    },
    downloadLink: {
        marginLeft: 6,
        color: theme.palette.text.blue,
        textDecoration: 'underline',
        fontWeight: 500,
    },
    instructions: {
        marginTop: theme.spacing(2),
        '& > label': {
            fontWeight: 500,
        },
        '& > ol': {
            padding: '0 0 0 14px',
            margin: `${theme.spacing()}px 0 ${theme.spacing(2)}px 0`,
        },
    },
    statusTable: {
        margin: `${theme.spacing(2)}px 0`,
    },
});

function GeneratTab({ classes, connector, isValid, mode }) {
    return (
        <div className={classes.root}>
            {mode === 'view' && (
                <Paragraph>
                    The Azure connector has been created. Return to Azure to
                    finish the setup.
                </Paragraph>
            )}
            <ConnectorStatusTable connector={connector} />
        </div>
    );
}

export default withStyles(styles)(GeneratTab);
